import React from 'react';
import {
    Card,
    CardBody,
    CardTitle,
    CardText,
    Button,
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody
} from 'reactstrap';
import {MdPieChart, MdCheck} from 'react-icons/lib/md';
import {apiGet, apiPost} from "../../../api";
import {urlGetCatalogoPlanesPymesDiners, urlRegistrarPlanesPymesDiners} from "../../../constants/urls";


class CotizacionPlanes extends React.Component {
    state = {
        selectedPlan: {
            id: null,
            tipo: null
        },
        planActualNombre: '',
        tipoPlan: '',
        modalCoberturaOpen: false,
        modalAsistenciaOpen: false,
        coberturasEspeciales: [],
        asistencias: [],
        planes: {},
        loading: true
    };

    componentDidMount() {
        this.cargarDatosDesdeAPI();
    }

    cargarDatosDesdeAPI = async () => {
        const {idCarrito} = this.props;
        const urlFinal = `${urlGetCatalogoPlanesPymesDiners}&idCarrito=${idCarrito}`;

        try {
            const response = await apiGet(urlFinal);
            this.setState({planes: response.planes, loading: false});

        } catch (error) {
            console.error('Error al obtener datos:', error);
            this.setState({planes: {}, loading: false});
        }
    };

    registrarPlanSeleccionado = async (planCompleto) => {
        try {
            const { idCarrito } = this.props; // ← asegúrate que venga por props

            const urlFinal = `${urlRegistrarPlanesPymesDiners}&idCarrito=${idCarrito}`;

            const response = await apiPost(urlFinal, {
                planSeleccionado: planCompleto
            });

           // console.log("✅ Plan registrado correctamente:", response);
            return response;
        } catch (error) {
            console.error("❌ Error al registrar plan:", error);
            return { transaccion: false };
        }
    };



    toggleCoberturaModal = (content = [], nombrePlan = '', tipoPlan = '') => {
        this.setState(prev => ({
            modalCoberturaOpen: !prev.modalCoberturaOpen,
            coberturasEspeciales: content,
            planActualNombre: nombrePlan,
            tipoPlan: tipoPlan
        }));
    };

    toggleAsistenciaModal = (content = [], nombrePlan = '', tipoPlan = '') => {
        this.setState(prev => ({
            modalAsistenciaOpen: !prev.modalAsistenciaOpen,
            asistencias: content,
            planActualNombre: nombrePlan,
            tipoPlan: tipoPlan

        }));
    };


    handlePlanSelection = (planId, tipoPlan) => {
        this.setState({selectedPlan: {id: planId, tipo: tipoPlan}});
    };




   /* handleNextClick = () => {
        const { selectedPlan, planes } = this.state;
        const { planesnormal = [], planesplus = [] } = planes;
        const planesFuente = selectedPlan.tipo === 'Plan Normal' ? planesnormal : planesplus;
        const selected = planesFuente.find(plan => plan.id === selectedPlan.id);

        if (!selected) return alert('Selecciona un plan');

        const dataToSend = {
            visible: 4,
            planSeleccionado: selected, // ← 🔁 aquí va el plan completo, tal como viene
            arrayCoberturas: [],
            prima: parseFloat(selected.prima),
            nombrePlan: selected.name,
            codigoProducto: this.props.codigoProducto,
            codGiroNegocio: this.props.codGiroNegocio,
            codigoRamo: this.props.codigoRamo
        };

        console.log("➡️ Enviando plan seleccionado completo:", dataToSend);

        this.props.handleNext(dataToSend);
    };*/
    handleNextClick = async () => {
        const { selectedPlan, planes } = this.state;
        const { planesnormal = [], planesplus = [] } = planes;

        let plan = planesnormal.find(p => p.id === selectedPlan.id);
        let tipoPlan = 'Plan Normal';

        if (!plan) {
            plan = planesplus.find(p => p.id === selectedPlan.id);
            tipoPlan = 'Plan Plus';
        }

        if (!plan) return alert('Selecciona un plan');

        const planCompleto = {
            ...plan,
            tipoPlan
        };

        // ✅ REGISTRAR PLAN SELECCIONADO ANTES DE CONTINUAR
        const respuestaRegistro = await this.registrarPlanSeleccionado(planCompleto);

        if (!respuestaRegistro) {
            alert("Hubo un error al registrar el plan. Intenta nuevamente.");
            return;
        }

        const dataToSend = {
            planSeleccionado: respuestaRegistro,
            arrayCoberturas: [],
            prima: parseFloat(plan.prima),
            nombrePlan: plan.name,
            codigoProducto: this.props.codigoProducto,
            codGiroNegocio: this.props.codGiroNegocio,
            codigoRamo: this.props.codigoRamo,
            planSelecionadoResponse: respuestaRegistro
        };

       // console.log("➡️ ENVIANDOOOOO:", dataToSend);

        this.props.handleNext(dataToSend);
    };
    formatCurrency = (valor) => {
        return new Intl.NumberFormat('es-EC', { style: 'currency', currency: 'USD' }).format(valor);
    }




    renderPlanes = (planes, tipoPlan) => {
        const {selectedPlan} = this.state;

        return planes.map(plan => {
            const isSelected = selectedPlan && selectedPlan.id === plan.id && selectedPlan.tipo === tipoPlan;


            return (
                <Col sm="4" key={plan.id}>
                    <Card style={{border: isSelected ? '2px solid #001560' : '1px solid #ccc'}} className="mb-4">
                        <CardBody>
                            <CardTitle tag="h5" className="text-center">{plan.name}</CardTitle>
                            <CardText className="text-center h2" style={{color: '#001560'}}>
                                ${parseFloat(plan.prima).toFixed(2)}
                            </CardText>
                            <CardText className="text-center">
                                <MdPieChart size="2.5em" className="text-warning"/>
                            </CardText>

                            <CardText className="my-3">
                                {plan.coberturas &&
                                    Object.values(plan.coberturas).map((grupo, index) => {
                                        const coberturasFiltradas = grupo.coberturas.filter(c => c.sumaAsegurada > 0);
                                        if (coberturasFiltradas.length === 0) return null;

                                        return (
                                            <small key={index} className="mb-1">
                                                <strong className="d-block mb-1">{grupo.nombre}</strong>
                                                {coberturasFiltradas.map(c => (
                                                    <div className="d-flex justify-content-between" key={c.codCobertura}>
                                                        <div style={{ width: '70%' }}>
                                                            <small>{c.nombreCobertura}</small>
                                                        </div>
                                                        <div className="font-weight-bold" style={{ width: '30%', textAlign: 'right' }}>
                                                            <small>{this.formatCurrency(c.sumaAsegurada)}</small>
                                                        </div>
                                                    </div>
                                                ))}
                                            </small>
                                        );
                                    })}
                            </CardText>

                            <hr/>
                            <div>
                                <div
                                    style={{color: '#D87C47', cursor: 'pointer'}}
                                    onClick={() => this.toggleAsistenciaModal(plan.asistencias, plan.name, tipoPlan)}
                                >
                                    Ver Asistencias
                                </div>

                                <div
                                    style={{color: '#001560', cursor: 'pointer'}}
                                    onClick={() => this.toggleCoberturaModal(plan.coberturasEspeciales, plan.name, tipoPlan)}
                                >
                                    Ver Coberturas Especiales
                                </div>
                            </div>

                            <Button
                                color={isSelected ? 'primary' : 'outline-primary'}
                                className="w-100 mt-3"
                                onClick={() => this.handlePlanSelection(plan.id, tipoPlan)}

                            >
                                Elijo este plan
                            </Button>
                        </CardBody>
                    </Card>
                </Col>
            );
        });
    };


    render() {
        const {handleBack, volverResumen} = this.props;
        const {
            selectedPlan,
            modalCoberturaOpen,
            modalAsistenciaOpen,
            coberturasEspeciales,
            asistencias,
            planes,
            loading
        } = this.state;

        if (loading) return <div className="text-center">Cargando planes...</div>;

        return (
            <div className="container mt-5">
                <h2>Planes Normal</h2>
                <Row>{this.renderPlanes(planes.planesnormal || [], 'Plan Normal')}</Row>

                <h2 className="mt-5">Planes Plus</h2>
                <Row>{this.renderPlanes(planes.planesplus || [], 'Plan Plus')}</Row>

                {/*{selectedPlan && selectedPlan.id && (
                    <h4 className="mt-4">
                        Plan Seleccionado: {selectedPlan.tipo} - ID {selectedPlan.id}
                    </h4>
                )}*/}


                <Modal isOpen={modalCoberturaOpen} toggle={this.toggleCoberturaModal} centered>
                    <ModalHeader toggle={this.toggleCoberturaModal}>

                        <small>
                            <span className="text-grey mr-2"> {this.state.tipoPlan} | </span>
                            <span className="text-dark ">{this.state.planActualNombre}:</span>
                            Coberturas especiales</small>

                    </ModalHeader>
                    <ModalBody>
                        {Array.isArray(coberturasEspeciales) && coberturasEspeciales.length > 0 ? (
                            <ul className="pl-3">
                                {coberturasEspeciales.map(c => (
                                    <li key={c.codigo} className="mb-2">
                                        <div className="d-flex">
                                            <div style={{width: "80%"}}>
                                                <small>{c.descripcion}</small>
                                            </div>
                                            <div className="font-weight-bold"
                                                 style={{width: "20%", textAlign: "right"}}>
                                                <small>{this.formatCurrency(c.valor)}</small>

                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p>No hay coberturas especiales disponibles.</p>
                        )}
                    </ModalBody>

                </Modal>

                <Modal isOpen={modalAsistenciaOpen} toggle={this.toggleAsistenciaModal} size="lg" centered>
                    <ModalHeader toggle={this.toggleAsistenciaModal}>
                        <small>
                            <span className="text-grey mr-2"> {this.state.tipoPlan} | </span>
                            <span className="text-dark">{this.state.planActualNombre}: </span>
                            Asistencias
                        </small>
                    </ModalHeader>
                    <ModalBody>
                        {Array.isArray(asistencias) && asistencias.length > 0 ? (
                            <ul className="pl-3">
                                {asistencias.map(a => (
                                    <li key={a.codigo}>
                                        <div className="d-flex align-items-center">
                                            <div style={{width: "80%"}}>
                                                <small>{a.descripcion}</small>
                                            </div>
                                            <div
                                                className="font-weight-bold"
                                                style={{textAlign: "right", width: "20%"}}
                                            >
                                                {a.valor === true ? (
                                                    <MdCheck className="text-success"/>
                                                ) : (
                                                    <small>{this.formatCurrency(a.valor)}</small>

                                                )}
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p>No hay asistencias disponibles.</p>
                        )}
                    </ModalBody>


                </Modal>

                <div className="mt-4 mb-4 d-flex justify-content-between" >
                        <Button
                            className="btn-detail-gray"
                            onClick={() => handleBack(1)}
                            disabled={volverResumen}>
                            <i className="fa fa-chevron-circle-left"/> REGRESAR
                        </Button>
                        <Button className="btn btn-primary" onClick={this.handleNextClick}>
                            <i className="fa fa-chevron-circle-right"/> CONTINUAR
                        </Button>
                </div>
            </div>
        );
    }
}

export default CotizacionPlanes;
